var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true, lock: true },
        },
      ],
      staticClass: "clearfix main_center",
    },
    [
      _c(
        "div",
        { staticClass: "right-content clearfix" },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [_c("span", [_vm._v("基本信息")])]
              ),
              _c(
                "el-form",
                {
                  staticClass: "form viewFormWrapper",
                  attrs: { "label-width": "152px" },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 15 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "项目编号：" } },
                            [_vm._v(_vm._s(_vm.form.projectCode) + " ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "项目名称：" } },
                            [_vm._v(_vm._s(_vm.form.projectName) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 15 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "标段名称：" } },
                            [_vm._v(_vm._s(_vm.form.bidName) + " ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "招标人名称：" } },
                            [_vm._v(_vm._s(_vm.form.tenderName) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 15 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "招标代理机构：" } },
                            [_vm._v(_vm._s(_vm.form.tenderAgentName) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [_c("span", [_vm._v("出证申请信息")])]
              ),
              _c(
                "el-form",
                {
                  staticClass: "form viewFormWrapper",
                  attrs: { "label-width": "152px" },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 15 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "申请单位：" } },
                            [_vm._v(_vm._s(_vm.questName) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 15 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "申请出证原因:" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              maxlength: "200",
                              "show-word-limit": "",
                              disabled: _vm.disable,
                            },
                            model: {
                              value: _vm.questReason,
                              callback: function ($$v) {
                                _vm.questReason = $$v
                              },
                              expression: "questReason",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [_c("span", [_vm._v("交易信息")])]
              ),
              _c(
                "el-form",
                {
                  staticClass: "form viewFormWrapper",
                  attrs: { "label-width": "152px" },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 15 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "项目受理日期：" } },
                            [_vm._v(_vm._s(_vm.form.projectHandleTime) + " ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "招标公告日期：" } },
                            [_vm._v(_vm._s(_vm.form.tenderNoticeTime) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 15 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "招标文件发售日期：" } },
                            [_vm._v(_vm._s(_vm.form.tenderFileTime) + " ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "评标专家抽取日期：" } },
                            [_vm._v(_vm._s(_vm.form.evalprofExtractTime) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 15 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "开标日期：" } },
                            [_vm._v(_vm._s(_vm.form.bidOpenTime) + " ")]
                          ),
                        ],
                        1
                      ),
                      _vm.form.bidopenRooms.length > 0
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "开标地点：" } },
                                _vm._l(_vm.form.bidopenRooms, function (room) {
                                  return _c(
                                    "span",
                                    {
                                      key: room,
                                      staticStyle: { "margin-right": "10px" },
                                    },
                                    [_vm._v(" " + _vm._s(room) + " ")]
                                  )
                                }),
                                0
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 15 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "评标日期：" } },
                            [_vm._v(_vm._s(_vm.form.evalTime))]
                          ),
                        ],
                        1
                      ),
                      _vm.form.evalRooms.length > 0
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "评标地点：" } },
                                _vm._l(_vm.form.evalRooms, function (room) {
                                  return _c("span", { key: room }, [
                                    _vm._v(" " + _vm._s(room) + " "),
                                  ])
                                }),
                                0
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 15 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "中标公示日期：" } },
                            [_vm._v(_vm._s(_vm.form.candidateTime) + " ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "中标公告日期：" } },
                            [_vm._v(_vm._s(_vm.form.resultNoticeTime) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 15 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "中标通知书发出日期：",
                                "label-width": "152px",
                              },
                            },
                            [_vm._v(_vm._s(_vm.form.noficationTime))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [_c("span", [_vm._v("中标信息")])]
              ),
              _c(
                "el-form",
                {
                  staticClass: "form viewFormWrapper",
                  staticStyle: {
                    "flex-wrap": "wrap",
                    "justify-content": "space-between",
                  },
                  attrs: { "label-width": "152px" },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 15 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "中标人名称：" } },
                            [_vm._v(_vm._s(_vm.form.winerName))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "中标金额：" } },
                            [
                              _vm._v(
                                _vm._s(_vm.form.winBidprice) +
                                  " " +
                                  _vm._s(_vm.form.winPriceUnitName) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 15 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "中标工期：" } },
                            [_vm._v(_vm._s(_vm.form.winWorkItem) + " 天 ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "项目负责人：" } },
                            [_vm._v(_vm._s(_vm.form.winProjectMainer) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "left-content" }, [
        _c(
          "div",
          { staticClass: "left-navbar" },
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.submitBtn,
                    expression: "submitBtn",
                  },
                ],
                staticStyle: { "margin-right": "10px" },
                attrs: { type: "primary", plain: "", size: "small" },
                on: {
                  click: function ($event) {
                    return _vm.submit()
                  },
                },
              },
              [_vm._v("提交")]
            ),
            _c(
              "el-button",
              {
                staticStyle: { "margin-left": "0" },
                attrs: { size: "small" },
                on: {
                  click: function ($event) {
                    return _vm.back()
                  },
                },
              },
              [_vm._v("返回")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }